import React from 'react';
import PropTypes from 'prop-types';
import { Jumbotron } from 'react-bootstrap';
import './style.scss';
import QuestionBlock from './question-block';

const MBTIBox = ({ data, handleAnswer }) => (
  <>
    <h2><b>I prefer:</b></h2>
    <Jumbotron className="mbti-box">
      {data?.groups?.map(item => (
        <QuestionBlock handleAnswer={handleAnswer} item={item} key={item.id} />
      ))}
    </Jumbotron>
  </>
);

MBTIBox.propTypes = {
  data: PropTypes.shape({
    groups: PropTypes.shape([]).isRequired
  }).isRequired,
  handleAnswer: PropTypes.func.isRequired
};

export default MBTIBox;
